var _rect, _rect2, _circle, _circle2, _circle3, _rect3, _line, _text, _line2, _path, _circle4, _circle5, _rect4, _text2, _line3, _line4, _rect5, _line5, _text3, _text4, _text5, _text6, _text7, _rect6, _rect7, _rect8, _rect9;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderLocationBannerWebPreview(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 168,
    viewBox: "0 0 202 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 200.5,
    height: 166.5,
    fill: "white",
    stroke: "#6A747F",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 200,
    height: 12,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8,
    r: 2.5,
    stroke: "#9BA3AB",
    strokeWidth: 0.5,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 8,
    r: 2.5,
    stroke: "#9BA3AB",
    strokeWidth: 0.5,
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 8,
    r: 2.5,
    stroke: "#9BA3AB",
    strokeWidth: 0.5,
    fill: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 24,
    width: 200,
    height: 16,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 40,
    x2: 201,
    y2: 40,
    stroke: "#D9DBDE",
    strokeWidth: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 35,
    fontFamily: "Arial, sans-serif",
    fontSize: 5.5,
    fill: "#6A747F",
    letterSpacing: 0.3
  }, "PICKUP ASAP - SAN BRUNO")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 181,
    y1: 28,
    x2: 183.5,
    y2: 28,
    stroke: "#6A747F",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.5,28 L185,35 L193,35 L195,29 L184.5,29",
    stroke: "#6A747F",
    strokeWidth: 0.7,
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.5,
    cy: 37.5,
    r: 1.2,
    fill: "#6A747F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 37.5,
    r: 1.2,
    fill: "#6A747F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 40,
    width: 200,
    height: 14,
    fill: "#6A747F"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 101,
    y: 50,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "white",
    textAnchor: "middle"
  }, "You are ordering Pickup at San Bruno")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 188,
    y1: 44,
    x2: 194,
    y2: 51,
    stroke: "white",
    strokeWidth: 0.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 194,
    y1: 44,
    x2: 188,
    y2: 51,
    stroke: "white",
    strokeWidth: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 54,
    width: 200,
    height: 36,
    fill: "#e9eaec"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 90,
    x2: 201,
    y2: 90,
    stroke: "#D9DBDE",
    strokeWidth: 0.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 104,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "#6A747F",
    letterSpacing: 0.3
  }, "SPECIALS")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 116,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "#6A747F",
    letterSpacing: 0.3
  }, "SOUPS")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 128,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "#6A747F",
    letterSpacing: 0.3
  }, "SALADS")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 140,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "#6A747F",
    letterSpacing: 0.3
  }, "DRINKS")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 152,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "#6A747F",
    letterSpacing: 0.3
  }, "KIDS")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 96,
    width: 52,
    height: 28,
    rx: 1,
    fill: "#E9EAEC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 96,
    width: 52,
    height: 28,
    rx: 1,
    fill: "#E9EAEC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 130,
    width: 52,
    height: 28,
    rx: 1,
    fill: "#E9EAEC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 130,
    width: 52,
    height: 28,
    rx: 1,
    fill: "#E9EAEC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderLocationBannerWebPreview);
export default __webpack_public_path__ + "static/media/order_location_banner_web_preview.5bcc44fe6b3db48868d1076c4c70cb6b.svg";
export { ForwardRef as ReactComponent };